
import { ProfessionalInfo } from '../../components/ProfessionalDetail/ProfessionalInfo';
import { BookingPanel } from '../../components/ProfessionalDetail/BookingPanel';
import { BookingModal } from '../../components/ProfessionalDetail/BookingModal';
import { ConfirmationModal } from '../../components/BookingPage/ConfirmationModal';

// Styles
import styles from './professional-detail.module.scss';
import Loading from '../../components/ui/Loading/Loading';
import { useProfessionalPage } from './hooks/useProfessionalPage';

const ProfessionalDetailPage = () => {
    const {
        professional,
        studies,
        availability,
        loading,
        error,
        slug,
        isBookingModalOpen,
        isConfirmationModalOpen,
        currentBookingUid,
        t,
        systemSettings,
        setIsBookingModalOpen,
        setIsConfirmationModalOpen,
        handleGoBack,
        handleConfirmBooking,
        handleBookingModalClose,
        user
    } = useProfessionalPage();

    if (loading) {
        return <Loading fullscreen text={t('landing.professionalsDetail.loading')} />;
    }

    if (error || !professional) {
        return (
            <div className="container text-center p-5">
                <p>{t('landing.professionalsDetail.error')}</p>
            </div>
        );
    }

    return (
        <div className={styles['professional-detail'] + " container"}>
          
            <div className={styles['professional-detail__content']}>
                <div className={styles['professional-detail__content__info']}>
                    <ProfessionalInfo
                        professional={professional}
                        studies={studies}
                        aboutSettings={systemSettings?.about}
                        professionalInfoSettings={systemSettings?.professional_info}
                    />
                </div>
                <div className={styles['professional-detail__content__booking']}>
                    <BookingPanel
                        professionalUid={professional.profile.uid || slug || ''}
                        availability={availability ?? []}
                        setIsBookingModalOpen={setIsBookingModalOpen}
                        modality={professional.profile.details?.consult_type ?? undefined}
                        consultTime={professional.profile.details?.consult_time ?? undefined}
                        consultPrice={professional.profile.details?.consult_price || 0}
                        currency={professional.profile.details?.currency || 'UYU'}
                        pricingMode={professional.profile.details?.pricing_mode || 'single'}
                        initialPrice={professional.profile.details?.initial_price || null}
                        initialDuration={professional.profile.details?.initial_duration ? Number(professional.profile.details.initial_duration) : null}
                        followupPrice={professional.profile.details?.followup_price || null}
                        followupDuration={professional.profile.details?.followup_duration ? Number(professional.profile.details.followup_duration) : null}
                        bookingMode={professional.profile.details?.booking_mode || 'direct'}
                        requestSchedule={professional.profile.details?.request_schedule}
                        messagingEnabled={['1', 1, 'true', true].includes(professional.profile.details?.messaging_enabled ?? true)}
                        professionalName={(professional.profile.first_name || '') + ' ' + (professional.profile.last_name || '')}
                        professionalPicture={professional.profile.details?.image || null}
                        isOwnProfile={user?.uid === (professional.profile.uid || slug)}
                    />
                </div>
            </div>
            <BookingModal
                open={isBookingModalOpen}
                onClose={handleBookingModalClose}
                onConfirmBooking={handleConfirmBooking}
                consultPrice={professional?.profile?.details?.consult_price ?? undefined}
                modality={professional.profile.details?.consult_type ?? undefined}
            />

            {currentBookingUid && (
                <ConfirmationModal
                    open={isConfirmationModalOpen}
                    onClose={() => setIsConfirmationModalOpen(false)}
                    // onViewDetails={handleViewDetails} 
                    bookingUid={currentBookingUid}
                />
            )}
        </div>
    );
};

export default ProfessionalDetailPage;